import { useNavigate, useLocation } from "react-router";
import { Button, Card, Form, Input, Layout, message } from "antd";
import LogoIcon from "../../assets/icons/latest_vivo_logo.svg?react";
import authService from "../../services/authService";
const { Header, Content } = Layout;

const passwordRegex =
  /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}|\\:;"'<>,.?/_₹[\]]).{8,}$/;

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  //read url params
  const searchParams = new URLSearchParams(location.search);
  //get hashed email from params
  const hashedemail = searchParams.get("v");
  //decode hashed email
  const email = hashedemail ? decodeURIComponent(hashedemail) : "";

  const [messageApi, contextHolder] = message.useMessage();

  const showErrorMsg = (message: string) => {
    messageApi.open({
      type: "error",
      content: message,
      duration: 5,
    });
  };

  const showSuccessMsg = () => {
    messageApi.open({
      type: "success",
      content: "You've successfully reset your password. Return to login.",
      duration: 8,
    });
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const onFinishFailed = () => {
    // console.log("Failed:", errorInfo);
  };

  const onFinish = (values: {
    reset_code: string;
    new_password: string;
    confirmpassword: string;
  }) => {
    //remove confirmpassword from payload
    const payload: {
      reset_code: string;
      new_password: string;
      hash: string;
      confirmpassword?: string;
    } = { ...values, hash: email };
    delete payload.confirmpassword;

    const fetchResetPassword = async () => {
      try {
        const success = await authService.resetPassword(payload);

        if (success) {
          showSuccessMsg();
        } else {
          showErrorMsg("Error resetting password");
        }
      } catch (error) {
        showErrorMsg("Invalid data");
        console.error(error);
      }
    };
    fetchResetPassword();
  };

  return (
    <Layout className="main-auth-container">
      <Header className="header-auth-container">
        <LogoIcon className="mt-[30px]" />
      </Header>
      <Content>
        {contextHolder}
        <div className="flex flex-col justify-center items-center h-screen">
          <Card className="card-form" style={{ width: "530px" }}>
            <p className="text-[24px] font-bold mb-[10px]">
              Reset your password
            </p>
            <p className="text-[14px] text-[#556C75] mb-[30px]">
              Please enter the received reset code to change your password.
            </p>
            <Form
              name="basic"
              style={{
                maxWidth: 850,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                name="reset_code"
                rules={[
                  {
                    required: true,
                    message: "Please input your reset code.",
                  },
                ]}
              >
                <Input
                  size="large"
                  allowClear
                  placeholder="Reset code"
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item
                name="new_password"
                {...({ autoComplete: "off" } as any)}
                rules={[
                  {
                    required: true,
                    message: "Please input your new password.",
                  },
                  {
                    pattern: passwordRegex,
                    message:
                      "Your password must be at least 8 characters long, mixed case, and contain at least one letter, one number, and one special character.",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  allowClear
                  placeholder="New password"
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item
                name="confirmpassword"
                dependencies={["new_password"]}
                rules={[
                  {
                    required: true,
                    message: "Please retype your new password.",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match."),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  size="large"
                  allowClear
                  placeholder="Confirm new password."
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item className="text-center max-w-(--breakpoint-lg) px-8 mb-0">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="w-36 mt-2 rounded-sm shadow-none"
                >
                  Reset password
                </Button>
              </Form.Item>
            </Form>
            <div className="flex flex-col items-center">
              <p className="text-[40px] text-[#D5DADC]">|</p>
              <p className="mb-2 font-medium">Changed your mind?</p>
              <Button
                className="w-36 text-[#064C68] rounded-sm bg-[#D2EFF9] border-[#064C68]"
                onClick={goToLogin}
              >
                Return to log in
              </Button>
            </div>
          </Card>
        </div>
      </Content>
    </Layout>
  );
}
